import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BeneListService } from '../../../services/beneList.service';
import { Beneficiary } from '../../../interfaces/policy-admin-interfaces/beneficiary.interface';
import { Party } from '../../../interfaces/policy-admin-interfaces/party.interface';
import { ModalRouteService } from '../../../services/modal-route.service';

@Component({
  selector: 'bene-form-estate',
  templateUrl: './bene-form.estate.component.html',
})
export class BeneFormEstateComponent {
  protected beneForm: FormGroup;
  protected bene: Beneficiary;
  protected type: string;
  protected name: string;
  protected relationship: string;

  constructor(
    private beneListService: BeneListService,
    private modalRouteService: ModalRouteService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.bene = this.beneListService.getCurrentBene() as Beneficiary;
    this.type = this.beneListService.getPrimaryOrContingent();
    this.name = this.bene.partyInfo.name;
    this.relationship = this.bene.beneficiaryType;
  }

  saveBene(): void {
    this.bene = {
      ratio: 0,
      action: 'created',
      actionDate: this.bene.actionDate,
      beneficiaryType: this.relationship,
    };

    //if entity vs trust
    if (this.bene.beneficiaryType === '2') {
      //if estate
      const temp: Party = {
        name: "Insured's Estate",
        entity: {
          estate: true,
        },
      };
      this.bene.partyInfo = temp;
      this.bene.beneficiaryPartyType = 'estate';
    } else if (this.bene.beneficiaryType === '6') {
      //if trust
      const temp: Party = {
        name: "A trust under the insured's will",
        entity: {
          trust: true,
        },
      };
      this.bene.partyInfo = temp;
      this.bene.beneficiaryPartyType = 'trust';
    }

    this.beneListService.addBeneList(this.bene, this.type);

    this.modalRouteService.changeRoute('bene-list');
  }

  cancel(): void {
    this.modalRouteService.changeRoute('bene-list');
  }
}
